import {
  getModifiedDate,
  getPublishedDate,
} from '../../../scripts/utils/metadata-utils.js';
import { formatDate } from '../../../scripts/utils/text-utils.js';

export const getPublishedDateWithLabel = (item, i18next) => {
  const publishedDate = getPublishedDate(item);
  const label = i18next.t(
    'Generic.Item.PublicationDate.Public.Template',
    'Published on',
  );

  return `${label} ${formatDate(publishedDate)}`;
};

export const getModifiedDateWithLabel = (item, i18next) => {
  const modifiedDate = getModifiedDate(item);

  if (modifiedDate && modifiedDate !== '0') {
    const label = i18next.t(
      'Generic.Item.LastUpdateDate.Public.Template',
      'Updated on',
    );

    return `${label} ${formatDate(modifiedDate)}`;
  }
  return getPublishedDateWithLabel(item, i18next);
};

export const getReadingTime = (article) =>
  article.head.querySelector('meta[name="twitter:data2"]')?.content || '';

function normalizeUnixTimestamp(timestamp) {
  const numericTimestamp = Number(timestamp);

  if (Number.isNaN(numericTimestamp)) {
    return timestamp;
  }

  return numericTimestamp < 1000000000000
    ? numericTimestamp * 1000
    : numericTimestamp;
}

export function formatPublishedDateWithLabel(publishedDate, i18next) {
  const normalizedPublishedDate = normalizeUnixTimestamp(publishedDate);
  const label = i18next.t(
    'Generic.Item.PublicationDate.Public.Template',
    'Published on',
  );

  return `${label} ${formatDate(normalizedPublishedDate)}`;
}

export function formatModifiedDateWithLabel(modifiedDate, i18next) {
  const normalizedModifiedDate = normalizeUnixTimestamp(modifiedDate);
  const label = i18next.t(
    'Generic.Item.LastUpdateDate.Public.Template',
    'Updated on',
  );

  return `${label} ${formatDate(normalizedModifiedDate)}`;
}
